export default {
    // 英语
    LOCALE_HTML: {
        'msg.language': 'en',
        'msg.title': 'Title',
        'msg.type': 'Question Category',
        'msg.des': 'Question Description',
        'msg.phone': 'Phone',
        'msg.regionCode': 'Area Code',
        'msg.email': 'Email',
        'msg.choose': 'Select Business',
        'msg.detail': 'Message Details',
        'msg.back': 'Back',
        'your.msg': 'Leave Message',
        'msg.record': 'Message Record',
        'msg.success': 'Successfully Submitted',
        'to.record': 'Go to the Message Record',
        completed: 'Completed',
        submit: 'Submit',
        'success.desc':
            'Your message has been submitted successfully. Thank you for your feedback',
        'msg.form.input': 'Please enter',
        'msg.reply': 'Reply',
        'comment.suc': 'Thank you for your evaluation!',
        'comment.fail': 'Failed',
        'comment.placeholder': 'Tell us your suggestions',
        'reply.suc': 'Submitted Successfully!',
        'reply.fail': 'Please enter your reply',
        'reply.placeholder': 'Please enter your reply',
        'msg.more': 'See More',
        'msg.collapse': 'Collapse',
        'msg.myservice': 'My Service Feedback',
        'msg.evaluate': 'Feedback',
        'msg.evaluateTitle': 'Feedback',
        'msg.score': 'Score:',
        'msg.remark': 'Comment:',
        'msg.status.created': 'Created',
        'msg.status.pending': 'Pending',
        'msg.status.processing': 'Processing',
        'msg.status.solved': 'Solved',
        'msg.service.reply': 'Service Reply',
        'msg.my.reply': 'My Reply',
        'msg.toast.des': 'Description Required',
        'msg.toast.type': 'Question Category Required',
        'msg.toast.title': 'Title Required',
        'msg.toast.none': 'Cannot be empty',
        'msg.toast.noAnnex': 'Please upload attachments',
        'msg.toast.noEmail': 'Email Required',
        'msg.toast.noTel': 'Phone Required',
        'msg.toast.noRegionCode': 'The area code cannot be empty',
        'msg.toast.noZone': 'Please select time zone',
        'msg.toast.noDateTime': 'Please select date and time',
        'msg.toast.email': 'Please enter the correct email',
        'msg.toast.tel': 'Please enter the correct phone No.',
        'msg.toast.regionCode': 'Please select the area code',
        'msg.toast.num': 'Please enter the correct number',
        'msg.toast.annex': 'Please upload attachments',
        'msg.toast.char': 'Please enter the correct characte',
        'msg.list.none': 'No data',
        'msg.form.choose': 'Please select',
        'msg.form.chooseZone': 'Select time zone',
        'msg.form.chooseTime': 'Select Time',
        'msg.form.chooseDate': 'Select Date',
        'msg.form.sure': 'OK',
        'msg.form.search': 'Search...',
        'msg.form.uploadError':
            'The format of the uploaded attachment does not meet the requirements',
        'msg.form.uploadXss': 'Upload failed due to illegal scripts',
        'msg.update.time': 'Updated at',
        'msg.replace.images': 'Image',

        MSG016: 'Resolved',
        MSG017: 'Unresolved',
        MSG019: 'Submit',
        MSG072: 'Review label cannot be empty！',
        MSG073: 'Evaluation language cannot be empty！',
        MSG074: 'Tag:',
        MSG075: 'Resolved or Unresolved:',
        MSG076: 'Please select whether the question is resolved',
        MSG015: 'Did the ticket solve your problem?',

        'file.size.limit': 'File size must less than 50MB',
        'detail.file.limit': 'Up to 15 files, each within 50 MB',
        'form.question.des.tip': 'Please enter description',
        'form.title.tip': 'Please enter title',
        'form.class.tip': 'Please enter question category',
        'upload.file': 'Upload Attachments',
        'file.count.limit': 'Upload no more than 15 attachments',
        'select.search.placeholder': 'Search keywords',
        'msg.form.sizeError1': 'Please upload attachments less than 5M',
        'msg.form.sizeError2': 'Please upload attachments less than 50M',
        'msg.form.submit': 'Submitting...',
        'msg.form.upload': 'Uploading...',
        'msg.email.tip1': 'Did not find your message',
        'msg.email.tip2':
            'If you have a message before, you can check it through email verification',
        'msg.email.tip3': 'Start Email Verification',
        'msg.email.noData': 'No data for current account',
        'email.verify.tip': 'Email address used when leaving a message',
        'email.input.placeholder': 'Please enter email address',
        'email.submit': 'Send Email',
        'email.rules.error': 'Please enter correct email',
        'email.code.tip':
            'The email has been sent, please enter the verification code you received',
        'email.code.placeholder': 'Please enter verification code',
        'email.code.submit': 'View Now',
        'email.notFind.customer': 'Customer information not found',
        'email.code.wrong': 'The verification code is wrong, please re-enter',
        'email.code.expired':
            'The verification code has expired, please re-verify email',
        'email.code': 'Code',
        'email.send.frequently':
            'The operation is too frequent, please try again later',
        'comment.fail.400133': 'The ticket has been evaluated',
        'phone.placeholder': 'Please enter phone No.',
        'phone.error': 'Please enter correct phone No.',
        'not.get.user.info': 'Unable to get your info',
        'user.verify.tip':
            'You need to verify before you can view the content of the submission list',
        'verify.type.email': 'Email Verification',
        'verify.type.phone': 'SMS Verification',
        'get.verify.code': 'Get Verification Code',
        'reGet.verify.code': 'Re-acquire',
        'verify.text': 'Verification',
        'cancel.text': 'Cancel',
        'verify.by.email.tip':
            'The verification code will be sent via email to the email account you entered',
        'verify.by.phone.tip':
            'The verification code will be sent via SMS to the mobile no. you entered',
        'phone.errorCode400150': 'Verification code sent too frequently',
        'phone.errorCode400233': 'SMS template cannot be blank',
        'phone.errorCode400234': 'Insufficient marketing SMS balance',
        'phone.errorCode400235': 'Insufficient notification SMS balance',
        'phone.errorCode400247': 'Ticket plug-in SMS configuration error',
        'phone.errorCode4400248': 'Failed to acquire SMS template',
        'phone.errorCode400249': 'Not current user phone no.',
        'phone.errorCode400250': 'Verification code expired. Get a new one.',
        'msg.you.reply': 'Replied to you',
        'msg.no.reply':'No reply',

    },
    LOCALE_REQUEST: {
        400016: 'The ticket information has expired, please refresh!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'Remove',
                cancel: 'Cancel',
                confirm: 'OK',
                inert: 'Insert',
                width: 'Width',
                height: 'Height'
            },
            controls: {
                clear: 'Clear',
                undo: 'Undo',
                redo: 'Redo',
                fontSize: 'Font Size',
                color: 'Color',
                textColor: 'Text',
                tempColors: 'Temp Colors',
                backgroundColor: 'Background',
                bold: 'Bold',
                lineHeight: 'Line Height',
                letterSpacing: 'Letter Spacing',
                textIndent: 'Text Indent',
                increaseIndent: 'Increase Indent',
                decreaseIndent: 'Decrease Indent',
                italic: 'Italic',
                underline: 'Underline',
                strikeThrough: 'Strike Through',
                fontFamily: 'Font Family',
                textAlign: 'Text Alignment',
                alignLeft: 'Left Alignment',
                alignCenter: 'Center Alignment',
                alignRight: 'Right Alignment',
                alignJustify: 'Justify Alignment',
                floatLeft: 'Left Float',
                floatRight: 'Right Float',
                superScript: 'Super Script',
                subScript: 'Sub Script',
                removeStyles: 'Remove Styles',
                headings: 'Headings',
                header: 'Header',
                normal: 'Normal',
                orderedList: 'Ordered List',
                unorderedList: 'Unordered List',
                blockQuote: 'Quote',
                code: 'Code',
                link: 'Link',
                unlink: 'Unlink',
                hr: 'Horizontal Line',
                media: 'Media',
                mediaLibirary: 'Media Library',
                emoji: 'Emoji',
                fullscreen: 'Fullscreen',
                exitFullscreen: 'Exit Fullscreen'
            },
            linkEditor: {
                textInputPlaceHolder: 'Enter link text',
                linkInputPlaceHolder: 'Enter link URL',
                inputWithEnterPlaceHolder: 'Enter link URL and press Enter',
                openInNewWindow: 'Open in new window',
                removeLink: 'Remove Link'
            },
            audioPlayer: {
                title: 'Play Audio'
            },
            videoPlayer: {
                title: 'Play Video',
                embedTitle: 'Embed Media'
            },
            media: {
                image: 'Image',
                video: 'Video',
                audio: 'Audio',
                embed: 'Embed'
            }
        },
        finder: {
            remove: 'Remove',
            cancel: 'Cancel',
            confirm: 'OK',
            insert: 'Insert Selected Items',
            width: 'Width',
            height: 'Height',
            image: 'Image',
            video: 'Video',
            audio: 'Audio',
            embed: 'Embed',
            caption: 'Media Library',
            dragTip: 'Click Or Drag Files Here',
            dropTip: 'Drop To Upload',
            selectAll: 'Select All',
            deselect: 'Deselect',
            removeSelected: 'Remove Selected Items',
            externalInputPlaceHolder: 'Source Name|Source URL',
            externalInputTip:
                'Split source name and source URL with "|", confirm by hit Enter.',
            addLocalFile: 'Add From Local',
            addExternalSource: 'Add From Internet',
            unnamedItem: 'Unnamed Item',
            confirmInsert: 'Insert Selected Items'
        }
    }
}
